(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(section) {
    if (section.dataset.collectionInit) return;
    section.dataset.collectionInit = '1';

    var sectionId = section.dataset.sectionId;
    var form = section.querySelector('[data-filters-form]');
    var sortSelect = section.querySelector('[data-sort-select]');
    var sortMirror = section.querySelector('[data-filters-sort-mirror]');
    var resultsRegion = section.querySelector('#CollectionResults') || section;
    var debounce;

    function buildUrl() {
      var base = window.location.pathname;
      var params = new URLSearchParams();
      if (form) {
        new FormData(form).forEach(function (val, key) {
          if (val !== '' && key !== 'sort_by') params.append(key, val);
        });
      }
      if (sortSelect && sortSelect.value) params.set('sort_by', sortSelect.value);
      var qs = params.toString();
      return qs ? base + '?' + qs : base;
    }

    function render(url, push) {
      var products = section.querySelector('.collection-products');
      if (products) products.setAttribute('data-results-busy', 'true');

      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
      fetch(fetchUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newSection = doc.querySelector('[data-collection-section]') || doc;
          var swaps = ['#CollectionResults', '#CollectionFilters'];
          swaps.forEach(function (sel) {
            var fresh = newSection.querySelector(sel);
            var current = section.querySelector(sel);
            if (fresh && current) current.innerHTML = fresh.innerHTML;
          });
          if (push) window.history.pushState({ collection: true }, '', url);
          bindResults();
          var top = section.getBoundingClientRect().top + window.pageYOffset - 80;
          if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
        })
        .catch(function () { window.location.href = url; });
    }

    function update(push) { render(buildUrl(), push !== false); }

    function bindResults() {
      resultsRegion = section.querySelector('#CollectionResults') || section;

      var freshSort = section.querySelector('[data-sort-select]');
      if (freshSort) {
        sortSelect = freshSort;
        sortSelect.addEventListener('change', function () {
          if (sortMirror) sortMirror.value = sortSelect.value;
          update();
        });
      }

      section.querySelectorAll('[data-filter-remove]').forEach(function (link) {
        link.addEventListener('click', function (e) { e.preventDefault(); render(link.getAttribute('href'), true); });
      });
      section.querySelectorAll('[data-pagination] a').forEach(function (link) {
        link.addEventListener('click', function (e) { e.preventDefault(); render(link.getAttribute('href'), true); });
      });

      var toggle = section.querySelector('[data-filters-toggle]');
      var panel = section.querySelector('#CollectionFilters');
      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          var open = panel.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          document.body.style.overflow = open ? 'hidden' : '';
        });
      }
    }

    if (form) {
      form.addEventListener('input', function (e) {
        if (e.target.type === 'number') {
          clearTimeout(debounce);
          debounce = setTimeout(function () { update(); }, 500);
        } else {
          update();
        }
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); update(); });
    }

    window.addEventListener('popstate', function () { render(window.location.href, false); });
    bindResults();
  }

  function boot() {
    document.querySelectorAll('[data-collection-section]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
